import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { SbAnimatedNumberComponent } from '../sb-animated-number/sb-animated-number.component';
import { fadeInOut } from '../../animations/fade-in-out.animation';
import { SbPendingButtonIndicatorComponent } from '../sb-pending-button-indicator/sb-pending-button-indicator.component';
import { DecimalFormatStyleType } from '@phensley/cldr-core/lib/common/numbers';
import { BehaviorSubject, debounceTime } from 'rxjs';

@Component({
    selector: 'sb-notification-badge',
    standalone: true,
    imports: [
        CommonModule,
        MatTooltipModule,
        SbAnimatedNumberComponent,
        SbPendingButtonIndicatorComponent
    ],
    templateUrl: './sb-notification-badge.component.html',
    styleUrls: ['./sb-notification-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [fadeInOut]
})
export class SbNotificationBadgeComponent {
    get isIconBadge(): boolean {
        return this._isIconBadge;
    }

    /** iconBadge
     * @description Attach badge to icon
     * @param value
     */
    @Input() set iconBadge(value: boolean) {
        this._isIconBadge = value;
    }
    get isLoading(): boolean {
        return this._isLoading;
    }

    /** isLoading
     * @description Show loading spinner if badge is waiting for data to be loaded
     * @param value
     */
    @Input() set isLoading(value: boolean) {
        this._isLoading = value;
    }
    get tooltip() {
        return this._tooltip;
    }

    /** tooltip
     * @description Tooltip text to show on hover
     * @param value
     */
    @Input() set tooltip(value: string) {
        this._tooltip = value;
    }

    // Refactored this to use a BehaviorSubject to be able to debounce the inputs
    // As part of SWIN-6582 fixes
    // When we use signals, we might be able to revert this change
    // get numberOfNotifications() {this._numberOfNotifications);
    //     return this._numberOfNotifications;
    // }

    // private _numberOfNotifications = -1;

    /** numberOfNotifications
     * @description Number of notifications to show in badge
     * @param value
     */
    @Input() set numberOfNotifications(value) {
        if (value > 999) {
            this.style = 'short';
            this.suffix = '+';
        } else {
            this.style = 'decimal';
            this.suffix = '';
        }
        //this._numberOfNotifications = value;
        this._notificationSubject$.next(value);
    }
    private _notificationSubject$ = new BehaviorSubject<number>(-1);
    numberOfNotifications$ = this._notificationSubject$.pipe(debounceTime(100));
    private _tooltip;
    private _isLoading = false;
    style: DecimalFormatStyleType = 'decimal';
    suffix = '';
    private _isIconBadge: boolean = false;
}
